<template>
  <ul :id="`tree-node-actions-${nodo.id}`">
    <li>
      <span class="node-activation-date">
      {{ activationDate }}
      </span>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'MoleculeEditionAssetContentsTreeNodeActivationCalendar',

  props: {
    contenido: Object,

    element: Object,

    info: {
      type: Object,
      default: null
    },

    nodo: Object,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      diaNodo: ''
    }
  },

  computed: {
    activationDate () {
      if (this.diaNodo === '') {
        return this.$t('mEditionAssetContentsTreeNodeActivation.messages.notActivated')
      } else if (this.diaNodo === 0) {
        return this.element.fecha_inicio
          ? this.$utils.formatISODateTime(this.element.fecha_inicio)
          : this.$t('mEditionAssetContentsTreeNodeActivation.messages.inmediate')
      } else {
        return this.element.fecha_inicio
          ? this.$moment.parseZone(this.element.fecha_inicio).add(parseInt(this.diaNodo), 'days').format('YYYY-MM-DD')
          : this.$t('mEditionAssetContentsTreeNodeActivation.messages.daysAfter')
      }
    }
  },

  watch: {
    'info' () {
      let nodo = this.searchDay(this.nodo.id)
      if (nodo) {
        this.diaNodo = nodo.dia === -1 ? '' : nodo.dia
      }
    }
  },

  created () {
    let nodo = this.searchDay(this.nodo.id)
    if (nodo) {
      this.diaNodo = nodo.dia === -1 ? '' : nodo.dia
    }
  },

  methods: {
    changeDay (event) {
      this.$emit('emitAction', { nodo: this.nodo.id, dia: event.target.value })
    },

    searchDay (idNodo) {
      return this.info.nodosActivos.nodos.find(anodo => anodo.nodo === idNodo)
    }
  }
}
</script>
